<template>
  <MaskLayer>
    <div class="te-alert d-flex flex-column" :class="popupClass">
      <a href="#" class="close" style="z-index: 10;" @click="$emit('close')">
        <i class="material-icons">close</i>
      </a>
      <div class="content d-flex align-items-center flex-column flex-grow-1">
        <slot />
      </div>
      <div class="alert-btn">
        <button v-if="cancel" class="mx-1 btn btn-sm btn-light rounded-pill" @click="$emit('cancel')">
          <span class="px-3">{{ $t('common.cancel') }}</span>
        </button>
        <button class="mx-1 btn btn-sm btn-primary rounded-pill" @click="$emit('confirm')">
          <span class="px-3">{{ $t('common.confirm') }}</span>
        </button>
      </div>
    </div>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer';

export default {
  components: {
    MaskLayer
  },
  props: {
    cancel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: ''
    },
    alertBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    popupClass() {
      return {
        'te-alert-lg': this.size === 'lg',
        'te-alert-md': this.size === 'md',
        'no-alert-btn': !this.alertBtn
      };
    }
  }
};
</script>
